// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"LX-z","sponsoredTooltipWrapper":"MX-z","sponsoredTooltip":"NX-z","newCard":"OX-z"};